<template>
  <div id="layout">
    <el-container>
      <el-header style="height:70px">
        <Header></Header>
      </el-header>
      <el-container class="tableleft">
        <el-aside width="240px" v-show="show" class="asidemain">
          <Sidebar></Sidebar>
        </el-aside>
        <el-main>
          <router-view @getShopCode="getShopCode"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Sidebar from "./sidebar.vue";
import Header from "./Header.vue";
export default {
  components: {
    Sidebar,
    Header
    // HelloWorld,
    // Home
  },
  methods: {
    getShopCode (value) {
      this.show = value;
      // console.log(value);
    }
  },
  data () {
    return {
      show: true
    };
  },
  created () { },
  mounted () { }
};
</script>

<style scoped >
a {
  text-decoration: none;
}

.el-main {
  padding-top: 0;
}

.tableleft {
  padding-left: 20px;
}

.el-header {
  padding: 0;
}

.el-aside {
  min-height: 90vh;
  background: white;
}

.el-card__header {
  padding: 20px 20px 10px 20px;
}

.el-menu-item {
  font-size: 16px;
  text-align: center;
}
</style>
